var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer justify-center",class:this.$store.getters.tenant_short,attrs:{"app":"","darkheight":"30"}},[_vm._v(" "+_vm._s(_vm.$t("copyright"))+" "),_c('v-spacer'),_vm._v(_vm._s(this.$store.state.version)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }